// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TxReceipt_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxReceipt = exports.TxStatusCode = void 0;
const api_1 = require("./..");
const ledger_1 = require("../../ledger");
const transactions_1 = require("../transactions");
const typedjson_1 = require("../../export/typedjson");
const signature_1 = require("../signature");
const ethers_1 = require("ethers");
const util_1 = require("../util");
const assets_1 = require("../../ledger/assets");
const txReceiptTypeName = "TxReceipt";
var TxStatusCode;
(function (TxStatusCode) {
    TxStatusCode[TxStatusCode["Fail"] = 0] = "Fail";
    TxStatusCode[TxStatusCode["Success"] = 1] = "Success";
})(TxStatusCode = exports.TxStatusCode || (exports.TxStatusCode = {}));
let TxReceipt = TxReceipt_1 = class TxReceipt extends api_1.ErdstallObject {
    constructor(tx, delta, status, output, sig, hash, error) {
        super();
        this.tx = tx;
        this.delta = delta;
        this.status = status;
        this.output = output;
        this.sig = sig;
        this.hash = hash;
        this.error = error;
    }
    objectType() {
        return TxReceipt_1;
    }
    objectTypeName() {
        return txReceiptTypeName;
    }
    packTagged(_) {
        const enc = new util_1.ABIEncoder();
        return enc.pack(this.encodeABI(enc, _), ledger_1.Address.fromString(assets_1.ETHZERO));
    }
    encodeABI(e, _) {
        e.encode(["bytes", ethers_1.utils.arrayify(this.hash)], ["bytes", this.output.payload]);
        return "ErdstallTransactionOutput";
    }
    verify(contract) {
        console.log(ethers_1.utils.hexlify(this.packTagged(ledger_1.Address.fromString(assets_1.ETHZERO)).bytes));
        if (!this.sig) {
            return false;
        }
        const rec = ethers_1.utils.verifyMessage(this.packTagged(contract).keccak256(), this.sig.toString());
        console.log(rec);
        console.log(this.tx.sender.toString());
        return rec === this.tx.sender.toString();
    }
};
__decorate([
    typedjson_1.jsonMember(() => transactions_1.Transaction),
    __metadata("design:type", transactions_1.Transaction)
], TxReceipt.prototype, "tx", void 0);
__decorate([
    typedjson_1.jsonMember(transactions_1.TransactionOutput),
    __metadata("design:type", transactions_1.TransactionOutput)
], TxReceipt.prototype, "output", void 0);
__decorate([
    typedjson_1.jsonMember(() => signature_1.Signature),
    __metadata("design:type", signature_1.Signature)
], TxReceipt.prototype, "sig", void 0);
__decorate([
    typedjson_1.jsonMember(String),
    __metadata("design:type", String)
], TxReceipt.prototype, "hash", void 0);
__decorate([
    typedjson_1.jsonMapMember(String, () => ledger_1.Account, { shape: 1 /* OBJECT */ }),
    __metadata("design:type", Map)
], TxReceipt.prototype, "delta", void 0);
__decorate([
    typedjson_1.jsonMember(Number),
    __metadata("design:type", Number)
], TxReceipt.prototype, "status", void 0);
__decorate([
    typedjson_1.jsonMember(String),
    __metadata("design:type", String)
], TxReceipt.prototype, "error", void 0);
TxReceipt = TxReceipt_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [transactions_1.Transaction,
        Map,
        Number,
        transactions_1.TransactionOutput,
        signature_1.Signature, String, String])
], TxReceipt);
exports.TxReceipt = TxReceipt;
api_1.registerErdstallType(txReceiptTypeName, TxReceipt);
//# sourceMappingURL=txreceipt.js.map